import type { HistoryServiceV3 } from '@feature-hub/history-service';

export const clearOneLayerQuery = (layerLength: number, historyService: HistoryServiceV3) => {
  const hasDeepLink =
    window.location.hash.includes('one-layer=') || window.location.hash.includes('oneLayer=');

  if (hasDeepLink) {
    historyService?.history.go(-layerLength);
    const currentUrl = new URL(window.location.href);

    // Parse the existing hash parameters
    const hashParams = new URLSearchParams(window.location.hash.slice(1));

    // Remove the 'one-layer' parameter
    if (hashParams.has('one-layer')) {
      hashParams.delete('one-layer');
    } else if (hashParams.has('oneLayer')) {
      hashParams.delete('oneLayer');
    }

    const searchParams = new URLSearchParams(currentUrl.search);
    // Check if 'withFefa' exists before deleting
    if (searchParams.has('withFefa')) {
      // Handle search parameters
      const div = document.querySelector('#layer-content');
      div?.setAttribute('data-fefa-layer-active', 'false');
      searchParams.delete('withFefa');
      currentUrl.search = searchParams.toString();
    }

    // Reassign the updated hash back to the URL object
    currentUrl.hash = hashParams.toString();
    // Update the browser history without reloading
    historyService.rootHistory.replace(currentUrl.toString(), {});
  }
};

export const setAccessibilityForSiblings = (modalSelector: string, disable: boolean) => {
  const modal = document.querySelector(modalSelector);
  if (!modal || !modal.parentElement) return;
  const cleanupTrap = trapFocus(modal);
  if (!disable) {
    cleanupTrap?.();
  }
};

function trapFocus(modal: Element) {
  const focusableSelectors =
    'a[href], button, textarea, input, select, [tabindex]:not([tabindex="-1"])';
  const focusables = Array.from(modal.querySelectorAll<HTMLElement>(focusableSelectors));

  const first = focusables[0];
  const last = focusables[focusables.length - 1];

  function handleKeydown(e: KeyboardEvent) {
    if (e.key === 'Tab') {
      if (document.activeElement === last && !e.shiftKey) {
        e.preventDefault();
        first?.focus();
      }
      if (document.activeElement === first && e.shiftKey) {
        e.preventDefault();
        last?.focus();
      }
    }
  }

  function handleFocus(event: FocusEvent) {
    if (!modal.contains(event.target as Node)) {
      // Focus escaped – restore it
      first?.focus();
    }
  }

  document.addEventListener('keydown', handleKeydown);
  document.addEventListener('focus', handleFocus, true); // useCapture=true

  return () => {
    document.removeEventListener('keydown', handleKeydown);
    document.removeEventListener('focus', handleFocus, true);
  };
}
